<template>
  <div class="no-results">
    <div class="content-panel panel">
      <h6 class="no-results--heading">
        Oppps! Non abbiamo trovato proposte per la tua ricerca. Che fare?
      </h6>
      <b-row class="no-results--row">
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="filters" />
            <button
              type="button"
              class="no-results--title no-results--action"
              @click="$emit('open-filters')"
            >
              Elimina i filtri
            </button>
            <div class="no-results--text">
              Hai inserito troppi filtri?
              <br />
              Prova con meno filtri.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="calendar" />
            <div class="no-results--title">Prova su altre date</div>
            <div class="no-results--text">
              Le compagnie low cost hanno ridotto il numero di voli settimanali
              per cui prova tutti i giorni della settimana.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="pin" />
            <div class="no-results--title">Usa il nome della città</div>
            <div class="no-results--text">
              Non usare il nome dell'aeroporto (ex. Malpensa o MXP) ma il nome
              della città (Tutti gli aeroporti di Milano).
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'no-results',
  };
</script>

<style lang="scss" scoped>
  .no-results {
    text-align: center;
    margin-bottom: $grid-gutter-width;
    .panel {
      padding: $grid-gutter-width $grid-gutter-width;
    }
    &--heading {
      @extend .h6 !optional;
      margin-bottom: $grid-gutter-width;
    }
    &--row {
      // Vertical gap only affects the stacked layout (cards wrap onto separate
      // lines below md); the column gutters keep them apart side by side.
      row-gap: $grid-gutter-width;
    }
    &--icon {
      margin-bottom: 8px;
    }
    &--title {
      font-size: 16px;
    }
    &--action {
      background: none;
      border: 0;
      padding: 0;
      font: inherit;
      color: inherit;
      cursor: default;
      user-select: text;

      // The filters sidebar is reachable on larger screens, so there the button
      // stays plain text; only on smaller screens (where the sidebar is
      // off-canvas) does it read and behave as an interactive link.
      @include media-breakpoint-down(xl) {
        color: var(--primary);
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &--text {
      font-size: 12px;
      max-width: 200px;
      margin: 0 auto;
    }
    &--item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  }
</style>
